import flow from 'lodash/flow';
import get from 'lodash/get';
import nth from 'lodash/nth';
import replace from 'lodash/replace';
import split from 'lodash/split';

const getLocalValue = (str: string, localStorage: Storage) =>
  localStorage ? localStorage.getItem(str) : null;

const toJson = (str: string) => {
  try {
    return JSON.parse(str);
  } catch (e) {
    return null;
  }
};

const getUserId = (parsedToken: any) =>
  get(
    parsedToken,
    'body.decodedToken.claims.http://seek/claims/act_as/user_id',
  ) || get(parsedToken, 'body.decodedToken.claims.http://seek/claims/user_id');

const getAuthToken = (parsedToken: any) =>
  replace(get(parsedToken, 'data.token'), 'Bearer ');

const extractSeekerIdFromL7JwtPayload = (jwtString: string) => {
  try {
    const payloadString = nth(split(jwtString, '.', 2), 1);
    const payload = toJson(atob(payloadString || ''));

    return get(payload, 'sub.id');
  } catch (e) {
    return null;
  }
};

const getJobseekerIdFromAuth0Token = (
  auth0Key: string,
  localStorage: Storage,
) => flow([getLocalValue, toJson, getUserId])(auth0Key, localStorage);

const getFromL7Token = (localStorage: Storage) =>
  flow([getLocalValue, toJson, getAuthToken, extractSeekerIdFromL7JwtPayload])(
    'SeekAuthorisationToken',
    localStorage,
  );

const getJobSeekerId = (
  localStorage: Storage = window.localStorage,
): string | undefined => {
  const auth0LocalStorageKey =
    localStorage &&
    Object.keys(localStorage).find((key) => key.startsWith('@@auth0'));

  return (
    (auth0LocalStorageKey
      ? getJobseekerIdFromAuth0Token(auth0LocalStorageKey, localStorage)
      : getFromL7Token(localStorage)) || ''
  );
};

export default getJobSeekerId;
